var map = {
	"./de.json": 8905,
	"./en.json": 58898,
	"./es.json": 99284,
	"./fr.json": 60419,
	"./it.json": 49311,
	"./nl.json": 46183,
	"./pt_BR.json": 46731
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 24168;